async function unavailable() {
    throw new Error('Secure storage is available only in the native app.');
}

export const getItem = unavailable;
export const setItem = unavailable;
export const removeItem = unavailable;
export const migrateStorage = unavailable;
